var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mu-carousel',[_c('mu-carousel-item',[_c('img',{attrs:{"src":require("../assets/b1.png")}})]),_vm._v(" "),_c('mu-carousel-item',[_c('img',{attrs:{"src":require("../assets/b2.png")}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7514755f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel.vue
// module id = null
// module chunks = 